import { WesService } from 'shared/services/WesService'

export const deleteFavorite = async ({ favoriteId, authorizationHeader }: VP.DTT.Mutations.WorkEntityService.DeleteMutationVariables): Promise<number> =>
  WesService.removeFavorite(favoriteId, authorizationHeader)
